import React from 'react'
import { Link } from 'react-router-dom'

import Image from '../../image'
import Tag from '../../content/Tag'
import InlineSvg from '../../image/InlineSvg'
import DateRow from '../DateRow'

const ROW_HEIGHT = 'h-[78px]'
const LEFT_COLUMN_WIDTH = 'w-[70px]'

type Props = { children: React.ReactNode, linkTo: string }
const RowCard: React.FC<Props> = ({ children, linkTo }) => {
  return (
    <Link to={linkTo}>
      <div className={`bg-white ${ROW_HEIGHT} overflow-hidden rounded-md block align-middle`}>
        {children}
      </div>
    </Link>
  )
}

type CompanyRowCardProps = { imgSrc: string, tagLabel: string, id: number | string }
export const CompanyRowCard: React.FC<CompanyRowCardProps> = ({ id, imgSrc, tagLabel  }) => {
  return (
    <RowCard linkTo={`/companies/${id}`}>
      <div className='inline-block w-full max-w-[50%]'><Image className={`${ROW_HEIGHT} overflow-hidden inline-block object-contain ml-4 py-4`} src={imgSrc} alt={imgSrc} /></div>
      <div className='p-4 text-end w-[50%] inline-block'><Tag solid>{tagLabel}</Tag></div>
    </RowCard>
  )
}

type VideoRowCardProps = { id: number | string, title: string, description: string, imgSrc: string }
export const VideoRowCard: React.FC<VideoRowCardProps> = ({ id, imgSrc, title, description  }) => {
  return (
    <RowCard linkTo={`/content/videos/${id}`}>
      <div className='flex'>
        <div className={LEFT_COLUMN_WIDTH}>
          <Image className='h-full w-full' src={imgSrc} alt={title} />
        </div>
        <div className='w-[75%] p-3'>
          <p className='text-black text-xs line-clamp-2 h-10'>{title}</p>
          <p className='mt-0.5 text-gray-600 font-light text-2xs line-clamp-1'>{description}</p>
        </div>
      </div>
    </RowCard>
  )
}

type DocumentRowCardProps = { id: number | string, title: string, description: string, icon: string }
export const DocumentRowCard: React.FC<DocumentRowCardProps> = ({ id, icon, title, description  }) => {
  return (
    <RowCard linkTo={`/content/documents/${id}`}>
      <div className='flex w-full h-full'>
        <div className={`${LEFT_COLUMN_WIDTH} bg-soft-green text-center flex items-center justify-center`}>
          <InlineSvg src={icon} className='scale-150 stroke-deep-green overflow-hidden' />
        </div>
        <div className='w-[75%] p-3'>
          <p className='text-black text-xs line-clamp-2 h-10'>{title}</p>
          <p className='mt-0.5 text-gray-600 font-light text-2xs line-clamp-1'>{description}</p>
        </div>
      </div>
    </RowCard>
  )
}

type EventRowCardProps = { id: number | string, title: string, description: string, startDate: Date, endDate: Date }
export const EventRowCard: React.FC<EventRowCardProps> = ({ id, startDate, endDate, title, description  }) => {
  return (
    <RowCard linkTo={`/content/documents/${id}`}>
      <DateRow startDate={startDate} endDate={endDate} showEndDate={false} leftColWidth={LEFT_COLUMN_WIDTH}>
        <div>
          <p className='text-black text-xs line-clamp-2 h-10'>{title}</p>
          <p className='mt-0.5 text-gray-600 font-light text-2xs line-clamp-1'>{description}</p>
        </div>
      </DateRow>
    </RowCard>
  )
}


